import reducer from "./reducer";
export { default as Schooling } from "./components/index";
export { default as schoolingReducerName } from "./constants";
export default reducer;
